<template>
  <div class="navbar">
    <el-menu class="navbar" mode="horizontal">
      <!-- 折叠菜单 -->
      <hamburger :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container"/>
      <!-- 面包屑导航 -->
      <breadcrumb class="breadcrumb-container"/>
      <div class="right-menu">
        <!-- 全局查询菜单 -->
        <headerSearch class="right-menu-item" />
        <!-- 中英文切换 -->
        <lang-select class="international right-menu-item"/>
        <el-dropdown class="avatar-container" trigger="click">
          <div class="avatar-wrapper">
            <img :src="orignUserPhoto" class="user-avatar">
            <i class="el-icon-caret-bottom"/>
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <el-dropdown-item divided>
              <span style="display:block;"> {{ $store.state.user.loginName }} </span>
            </el-dropdown-item>
            <el-dropdown-item divided v-if="isShow">
              <span style="display:block;" @click="updatePwd">{{ this.$t('lang.修改密码') }}</span>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <span style="display:block;" @click="updatePhoto">{{ this.$t('lang.修改头像') }}</span>
            </el-dropdown-item>
            <el-dropdown-item divided v-if="isShow">
              <span style="display:block;" @click="logout">{{ this.$t('lang.退出登录') }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-menu>
    <!-- 修改密码 -->
    <el-dialog
      :visible.sync="dialogValObjVisible"
      :title="this.$t('lang.修改密码')"
      width="950px">
      <el-form ref="valObj" :model="valObj" :rules="rule">
        <table>
          <tr>
            <td>
              <el-form-item
                :label-width="formLabelWidth"
                :label="$t('lang.用户名')"
                prop="username">
                <el-input v-model="valObj.username" disabled/>
              </el-form-item>
            </td>
            <td>
              <el-form-item
                :label-width="formLabelWidth"
                :label="$t('lang.原始密码')"
                prop="oldPwd">
                <el-input v-model="valObj.oldPwd" type="password"/>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item
                :label-width="formLabelWidth"
                :label="$t('lang.新密码')"
                prop="pwd">
                <el-input v-model="valObj.pwd" type="password"/>
              </el-form-item>
            </td>
            <td>
              <el-form-item
                :label-width="formLabelWidth"
                :label="$t('lang.确认新密码')"
                prop="rePwd">
                <el-input v-model="valObj.rePwd" type="password"/>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelPwd">{{ this.$t('lang.取消') }}</el-button>
        <el-button type="primary" @click="sureDiaglogOperate">{{ this.$t('lang.确认') }}</el-button>
      </span>
    </el-dialog>
    <!-- 修改头像 -->
    <el-dialog
      :visible.sync="dialogPhotoVisible"
      :title="this.$t('lang.修改头像')"
      :modal-append-to-body="false">
      <div class="upload_images">
        <el-upload
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
          class="avatar-uploader"
          name="uploadFile"
          action="">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <!-- 暂时没有服务器存图片，暂不支持本地图片上传 -->
          <!-- <i v-else class="el-icon-plus avatar-uploader-icon"/> -->
        </el-upload>
        <div class="imagesDiv">
          <span style="font-size: 14px;">{{ this.$t('lang.可选择') }}:</span>
          <img
            v-for="item in imageAllSrc"
            :key="item.id"
            :src="item.imageurl"
            alt=""
            width="50px"
            @click="changeImg(item.imageurl)">
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPhotoVisible = false;">{{ this.$t('lang.取消') }}</el-button>
        <el-button type="primary" @click="surePhotoOperate">{{ this.$t('lang.确认') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import LangSelect from '@/components/LangSelect'
import { addOrUpdateUserApi, userPhotoUpdate, updatePwd } from '@/api/privilege/privilege'
import headerSearch from '@/components/HeaderSearch'
import moment from 'moment' // 时间格式化
import qs from 'qs'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    LangSelect,
    headerSearch
  },
  data() {
    // 确认新密码的校验
    let validateConfrimPwd = (rule, value, callback) => {
      if (!value) {
        callback(this.$t('lang.请输入新密码'))
      } else if (value && value !== this.valObj.pwd) {
        callback(this.$t('lang.两次输入密码不一致'))
      } else {
        callback()
      }
    }
    // 验证修改密码的强度校验
    let validateStrongPwd = (rule, value, callback) => {
      this.bar1 = 'background: #031942'
      this.bar2 = 'background: #031942'
      this.bar3 = 'background: #031942'
      if (!value) {
        callback(this.$t('lang.请输入密码'))
      } else {
        if ((value + '').length < 6) {
          callback(this.$t('lang.请输入不少于6位的密码'))
        } else {
          callback()
        }
      }
    }
    return {
      dialogValObjVisible: false,
      dialogPhotoVisible: false,
      valObj: {
        username: '',
        pwd: '',
        oldPwd: '',
        rePwd: ''
      },
      // 原始密码
      password: '123456',
      formLabelWidth: '220px',
      rule: {
        pwd: [{ required: true, validator: validateStrongPwd, trigger: 'blur' }],
        oldPwd: [{ required: true, message: this.$t('lang.请输入原始密码'), trigger: 'blur' }],
        rePwd: [{ required: true, validator: validateConfrimPwd, trigger: 'blur' }]
      },
      imageUrl: '',
      uploadFile: '',
      saveFile: '',
      // 可选择的图片
      imageAllSrc: [
        {
          id: '1',
          imageurl: require('../../../assets/user_image/1.jpg')
        },
        {
          id: '2',
          imageurl: require('../../../assets/user_image/2.jpg')
        },
        {
          id: '3',
          imageurl: require('../../../assets/user_image/3.jpg')
        },
        {
          id: '4',
          imageurl: require('../../../assets/user_image/4.jpg')
        },
        {
          id: '5',
          imageurl: require('../../../assets/user_image/5.jpg')
        },
        {
          id: '9',
          imageurl: require('../../../assets/login_images/console2.gif')
        }
      ],
      orignUserPhoto: this.orignUserPhotoUrl(),
      // 校验密码的强度条
      bar1: '',
      bar2: '',
      bar3: '',
      isShow: !window.glob.login
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ])
  },
  mounted() {
    this.language = this.$store.state.app.language
    if (this.language === 'zh') {
      this.formLabelWidth = '180px'
    } else {
      this.formLabelWidth = '220px'
    }
    // 密码强度提示
    if (this.$store.state.loginPwd === this.password) {
      this.$message.warning(this.$t('lang.您的密码强度太低，请尽快修改密码'))
    }
  },
  methods: {
    // 头像得地址 本地得头像 含有static
    orignUserPhotoUrl() {
      let url = this.$store.state.user.ImgUrl
      if (url) {
        if (url.indexOf('/static/img') !== -1) {
          return url
        } else {
          return window.glob.user + url
        }
      } else {
        return require('../../../assets/user_image/4.jpg')
      }
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    // 退出登陆
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    // 密码修改
    updatePwd() {
      this.bar1 = 'background: #031942'
      this.bar2 = 'background: #031942'
      this.bar3 = 'background: #031942'
      if (this.$refs['valObj'] !== undefined) {
        this.$refs['valObj'].resetFields()
        this.valObj = {}
      }
      this.dialogValObjVisible = true
      this.valObj.username = this.$store.state.user.loginName
    },
    // 取消修改密码
    cancelPwd() {
      this.valObj = {}
      this.valObj.pwd = ''
      this.valObj.rePwd = ''
      this.dialogValObjVisible = false
    },
    // 确定修改密码
    sureDiaglogOperate() {
      this.$refs['valObj'].validate(valid => {
        if (valid) {
          let postdata = {
            newPwd: this.valObj.pwd,
            oldPwd: this.valObj.oldPwd
          }
          postdata = qs.stringify(postdata)
          updatePwd(postdata).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: this.$t('lang.修改成功,请重新登录!')
              })
              this.dialogValObjVisible = false
              setTimeout(() => {
                this.logout()
              }, 2000)
            } else {
              this.$message({
                type: 'error',
                message: this.$t('lang.修改失败!')
              })
              this.dialogValObjVisible = false
            }
          })
        }
      })
    },
    // 头像修改
    updatePhoto() {
      this.imageUrl = ''
      this.saveFile = ''
      this.dialogPhotoVisible = true
    },
    // 头像上传
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG) {
        // 上传正确的图片格式!
        this.$message.error(this.$t('lang.请上传正确的图片格式（jpge/jpg/png/gif）'))
        this.imageUrl = ''
        return false
      }
      if (!isLt2M) {
        this.$message.error(this.$t('lang.图片大小超过1M，请重新选择!'))
        this.imageUrl = ''
        return false
      }
      let reg = /[`~!@#$%^&*()_+<>?:"{},./;'[\]]/im
      if (reg.test(file.name.split('.')[0])) {
        this.$message.error(this.$t('lang.图片命名中包含特殊字符，请规正命名再上传!'))
        this.imageUrl = ''
        return false
      }
      let windowURL = window.URL || window.webkitURL
      this.imageUrl = windowURL.createObjectURL(file) // 本地图片预览
      this.uploadFile = file
      return false
    },
    // 默认图片的点击事件
    changeImg(imageSrc) {
      this.imageUrl = imageSrc
      this.saveFile = imageSrc
    },
    // 提交头像
    surePhotoOperate() {
      if (!this.saveFile && !this.uploadFile) {
        this.$message.warning(this.$t('lang.请选择头像上传'))
      } else {
        if (!this.saveFile) {
        // 上传
          const formdata = new FormData()
          formdata.append('profile', this.uploadFile)
          userPhotoUpdate(formdata).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('lang.更改头像成功!'))
              this.orignUserPhoto = window.glob.user + 'picture/' + this.uploadFile.name.split('.')[0] + '_' + this.uploadFile.size + '_' + moment(new Date()).format('YYYYMMDDHH') + '.' + this.uploadFile.name.split('.')[1]
            } else {
              this.$message.error(this.$t('lang.更改头像失败!'))
            }
            this.dialogPhotoVisible = false
          })
        } else {
        // 选择的默认图片
          let postdata = {
            id: this.$store.state.user.userId,
            pictureUrl: this.saveFile
          }
          addOrUpdateUserApi(postdata).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('lang.更改头像成功!'))
              this.orignUserPhoto = postdata.pictureUrl
            } else {
              this.$message.error(this.$t('lang.更改头像失败!'))
            }
            this.dialogPhotoVisible = false
          })
        }
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.customClass{
  width: 320px;
  height: 120px;
  float: right;
  margin-top: 20px
}
.logo{
  margin-right: 200px
}
.el-notification{
  width: 400px;
}
.el-checkbox+.el-checkbox {
margin-left: 0px;
}
.el-checkbox {
margin-right: 10px;
}
.size-icon {
  font-size: 20px;
  cursor: pointer;
  vertical-align: -4px!important;
}
.item {
  margin-top: -26px;
  line-height: 0px;
  margin-right: 10px;
}
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container{
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    float: right;
    height: 100%;
    &:focus{
     outline: none;
    }
  .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(255, 0, 0, 0.025)
        }
      }
    }
    .screenfull {
      height: 20px;
    }
    .international{
      vertical-align: top;
    }
    .theme-switch {
      vertical-align: 15px;
    }
    .avatar-container {
      height: 50px;
      margin-right: 30px;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          -moz-border-radius: 50%;
          -webkit-border-radius: 50%;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.upload_images{
  width: 600px;
  height: auto;
  margin-left: 65px;
  .imagesDiv{
    img{
      display: inline-block;
      margin-right: 10px;
    }
  }
}
// 图片上传
.avatar-uploader{
    width: 178px;
    height: 178px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin-bottom: 20px;
}
  .avatar-uploader:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .clumnbox{
    display: flex;
    flex-flow: column nowrap;
    width: 30%;
    height: 40px;
    margin-bottom: -10px !important;
    text-align: center;
  }
  .clumnbox span:first-child{
    display: inline-block;
    width: 98%;
    height: 10px;
    border: solid 1px rgb(223, 222, 222);
  }
  .clumnbox span:last-child{
    margin-top: -5px;
  }
</style>
<style scoped>
  .impendingDia >>> .el-dialog__body{
    margin-top: -20px;
    padding: 0 20px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/menu/components/Navbar.vue